import {Api} from "@/repository/api";

export class ConfigRepository extends Api {
    constructor() {
        super("core/config");
    }
}